module.exports = __webpack_public_path__ + "static/img/1-2.bab4a1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/1-2.png
// module id = m/9m
// module chunks = 0